<template>
  <StatisticsHeader>
    <StatisticsPanel :load="load" v-slot="{ data }">
      <QuotesStats :data="data" />
    </StatisticsPanel>
  </StatisticsHeader>
</template>

<script>
import StatisticsHeader from "@/statistics/components/StatisticsHeader.vue";
import StatisticsPanel from "@/statistics/components/StatisticsPanel.vue";
import QuotesStats from "@/statistics/components/stats/QuotesStats.vue";
import {StatisticsController} from "@/statistics/controllers/StatisticsController";

export default {
  name: 'StatisticsQuotesView',
  components: {StatisticsHeader, StatisticsPanel, QuotesStats},
  methods: {
    load: urlParams => StatisticsController.getQuotes(urlParams),
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color: THEME_COLOR_PRIMARY
  span
    color: THEME_COLOR_PRIMARY_FADDED
</style>
